<template>
  <div class="sm-report-chargebacks">
    <div class="sm-wrap lg">
      <breadcrumbs-block :crumbs="breadcrumbs" />

      <div class="sm-report-chargebacks__block">
        <h3>Chargebacks</h3>
        <div 
          v-if="chargebacks.length"
          class="sm-report-chargebacks__block-table"
        >
          <table
            v-if="viewPort == 'large'"
            class="sm-table"
          >
            <thead class="sm-table__head">
              <tr class="sm-txt-upper">
                <th class="sm-table__head-item">Date</th>
                <th class="sm-table__head-item sm-txt-center">Mailbox#</th>
                <th class="sm-table__head-item">Name</th>
                <th class="sm-table__head-item sm-txt-center">Amount</th>
                <th class="sm-table__head-item sm-txt-center">Total</th>
                <th class="sm-table__head-item sm-txt-center">Status</th>
                <th class="sm-table__head-item">Original date</th>
                <th class="sm-table__head-item">Charge id</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in chargebacks"
                :key="item.account_id"
              >
                <td class="sm-txt-nowrap">{{new Date(item.date) | moment('MMM D, YYYY')}}</td>
                <td class="sm-txt-center">{{item.pmb}}</td>
                <td>
                  <text-truncate :text="item.name" />
                </td>
                <td class="sm-txt-center">{{formatPrice(item.amount)}}</td>
                <td class="sm-txt-center">{{formatPrice(item.total)}}</td>
                <td class="sm-txt-center">{{item.status}}</td>
                <td class="sm-txt-nowrap">{{item.original_date}}</td>
                <td>{{item.charge_id}}</td>
              </tr>
            </tbody>
          </table>

          <div 
            v-else
            class="sm-mobile-table"
          >
            <div class="sm-mobile-table-item header">
              <div class="sm-mobile-table-item-row">
                <div class="sm-mobile-table-item-row-th date">Date</div>
                <div class="sm-mobile-table-item-row-th sm-txt-center pmb">Mailbox#</div>
                <div class="sm-mobile-table-item-row-th name">Name</div>
                <div 
                  v-if="viewPort == 'medium'"
                  class="sm-mobile-table-item-row-th sm-txt-center amount"
                >Amount</div>
                <div class="sm-mobile-table-item-row-th sm-txt-center total">Total</div>
                <div
                  v-if="viewPort == 'medium'"
                  class="sm-mobile-table-item-row-th sm-txt-center status"
                >Status</div>
                <div class="sm-mobile-table-item-row-th control-arrow"></div>
              </div>
            </div>
            <div
              v-for="item in chargebacks"
              :key="item.account_id"
              class="sm-mobile-table-item"
              :class="{
                'open': item.isOpen
              }"
            >
              <div 
                class="sm-mobile-table-item-row"
                @click="toggleItem(item)"
              >
                <div class="sm-mobile-table-item-row-elem date">
                  <template v-if="viewPort == 'medium'">{{new Date(item.date) | moment('MMM D, YYYY')}}</template>
                  <template v-else>{{new Date(item.date) | moment('MMM D')}}</template>    
                </div>
                <div class="sm-mobile-table-item-row-elem sm-txt-center pmb">{{item.pmb}}</div>
                <div class="sm-mobile-table-item-row-elem name">
                  <text-truncate :text="item.name" />
                </div>
                <div
                  v-if="viewPort == 'medium'" 
                  class="sm-mobile-table-item-row-elem sm-txt-center amount"
                >{{formatPrice(item.amount)}}</div>
                <div class="sm-mobile-table-item-row-elem sm-txt-center total">{{formatPrice(item.total)}}</div><div 
                  v-if="viewPort == 'medium'" 
                  class="sm-mobile-table-item-row-elem sm-txt-center status"
                >{{item.status}}</div>
                <div class="sm-mobile-table-item-row-elem control-arrow">
                  <include-svg :name="'icon-arrow-b-big'" />
                </div>
              </div>
              <ul class="sm-mobile-table-item-dropdown">
                <li v-if="viewPort == 'small'">
                  <span class="sm-txt-capitalize">Amount</span>
                  <span>{{formatPrice(item.amount)}}</span>
                </li>
                <li v-if="viewPort == 'small'">
                  <span class="sm-txt-capitalize">Status</span>
                  <span>{{item.status}}</span>
                </li>
                <li>
                  <span class="sm-txt-capitalize">Original date</span>
                  <span>{{item.original_date}}</span>
                </li>
                <li>
                  <span class="sm-txt-capitalize">Charge id</span>
                  <span>
                    <text-truncate :text="item.charge_id" />
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <p
          v-else
          class="disabled"
        >You do not have any chargebacks</p>
      </div>
      <div class="sm-report-chargebacks__block">
        <h3>Refunds</h3>
        <div 
          v-if="refunds.length"
          class="sm-report-chargebacks__block-table"
        >
          <table
            v-if="viewPort == 'large'"
            class="sm-table"
          >
            <thead class="sm-table__head">
              <tr class="sm-txt-upper">
                <th class="sm-table__head-item">Date</th>
                <th class="sm-table__head-item sm-txt-center">Mailbox#</th>
                <th class="sm-table__head-item">Name</th>
                <th class="sm-table__head-item sm-txt-center">Amount</th>
                <th class="sm-table__head-item sm-txt-center">Total</th>
                <th class="sm-table__head-item sm-txt-center">Status</th>
                <th class="sm-table__head-item">Original date</th>
                <th class="sm-table__head-item">Charge id</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in refunds"
                :key="item.account_id"
              >
                <td class="sm-txt-nowrap">{{new Date(item.date) | moment('MMM D, YYYY')}}</td>
                <td class="sm-txt-center">{{item.pmb}}</td>
                <td>
                  <text-truncate :text="item.name" />
                </td>
                <td class="sm-txt-center">{{formatPrice(item.amount)}}</td>
                <td class="sm-txt-center">{{formatPrice(item.total)}}</td>
                <td class="sm-txt-center">{{item.status}}</td>
                <td class="sm-txt-nowrap">{{item.original_date}}</td>
                <td>{{item.charge_id}}</td>
              </tr>
            </tbody>
          </table>

          <div 
            v-else
            class="sm-mobile-table"
          >
            <div class="sm-mobile-table-item header">
              <div class="sm-mobile-table-item-row">
                <div class="sm-mobile-table-item-row-th date">Date</div>
                <div class="sm-mobile-table-item-row-th sm-txt-center pmb">Mailbox#</div>
                <div class="sm-mobile-table-item-row-th name">Name</div>
                <div 
                  v-if="viewPort == 'medium'"
                  class="sm-mobile-table-item-row-th sm-txt-center amount"
                >Amount</div>
                <div class="sm-mobile-table-item-row-th sm-txt-center total">Total</div>
                <div
                  v-if="viewPort == 'medium'"
                  class="sm-mobile-table-item-row-th sm-txt-center status"
                >Status</div>
                <div class="sm-mobile-table-item-row-th control-arrow"></div>
              </div>
            </div>
            <div
              v-for="item in refunds"
              :key="item.account_id"
              class="sm-mobile-table-item"
              :class="{
                'open': item.isOpen
              }"
            >
              <div 
                class="sm-mobile-table-item-row"
                @click="toggleItem(item)"
              >
                <div class="sm-mobile-table-item-row-elem date">
                  <template v-if="viewPort == 'medium'">{{new Date(item.date) | moment('MMM D, YYYY')}}</template>
                  <template v-else>{{new Date(item.date) | moment('MMM D')}}</template>    
                </div>
                <div class="sm-mobile-table-item-row-elem sm-txt-center pmb">{{item.pmb}}</div>
                <div class="sm-mobile-table-item-row-elem name">
                  <text-truncate :text="item.name" />
                </div>
                <div
                  v-if="viewPort == 'medium'" 
                  class="sm-mobile-table-item-row-elem sm-txt-center amount"
                >{{formatPrice(item.amount)}}</div>
                <div class="sm-mobile-table-item-row-elem sm-txt-center total">{{formatPrice(item.total)}}</div><div 
                  v-if="viewPort == 'medium'" 
                  class="sm-mobile-table-item-row-elem sm-txt-center status"
                >{{item.status}}</div>
                <div class="sm-mobile-table-item-row-elem control-arrow">
                  <include-svg :name="'icon-arrow-b-big'" />
                </div>
              </div>
              <ul class="sm-mobile-table-item-dropdown">
                <li v-if="viewPort == 'small'">
                  <span class="sm-txt-capitalize">Amount</span>
                  <span>{{formatPrice(item.amount)}}</span>
                </li>
                <li v-if="viewPort == 'small'">
                  <span class="sm-txt-capitalize">Status</span>
                  <span>{{item.status}}</span>
                </li>
                <li>
                  <span class="sm-txt-capitalize">Original date</span>
                  <span>{{item.original_date}}</span>
                </li>
                <li>
                  <span class="sm-txt-capitalize">Charge id</span>
                  <span>
                    <text-truncate :text="item.charge_id" />
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <p
          v-else
          class="disabled"
        >You do not have any refunds</p>
      </div>
    </div>

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import ViewPort from '@/mixins/ViewPort';
import Spinner from '@/components/Spinner';
import { mapActions } from 'vuex';
import {FormatPrice} from '@/utils/general-data';

export default {
  name: 'report-chargebacks',
  components: {
    'breadcrumbs-block': Breadcrumbs,
    'sm-spinner': Spinner
  },
  data() {
    return {
      breadcrumbs: [
        {
          link: 'reports',
          name: 'admin-reports',
          text: 'Reports'
        },
        {
          link: 'report-chargebacks',
          name: 'admin-report-chargebacks',
          text: 'Chargebacks & Refunds',
          current: true
        }
      ],
      chargebacks: [],
      refunds: [],
      allowedBreakpoints: [
        'small',
        'medium',
        'large'
      ],

      showSpinner: false
    }
  },
  created() {
    this.getData();
  },
  mixins: [ViewPort],
  methods: {
    ...mapActions({
      // getDetails: 'reports/getDetails',
      getChargebacksRefunds: 'reports/getChargebacksRefunds'
    }),
    formatPrice: FormatPrice,
    prepateItems(arr) {
      return arr.map(item => {
        const temp = {...item};
        temp.isOpen = false;
        return temp;
      })
    },
    toggleItem(item) {
      item.isOpen = !item.isOpen;
    },
    getData() {
      this.showSpinner = true;

      this.getChargebacksRefunds()
        .then(res => {
          this.chargebacks = res.chargebacks.map(item => {
            return {
              ...item,
              isOpen: false
            }
          });
          this.refunds = res.refunds.map(item => {
            return {
              ...item,
              isOpen: false
            }
          });
          this.showSpinner = false;
        });
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/reports/_report-chargebacks.scss';
</style>